import React, { useEffect, useState } from "react";
import Modal from "../../components/Modal";
import { Box, InputLabel, TextField, Typography, TableContainer, TableHead, TableRow, Table, TableCell, TableBody, Grid, Button } from "@mui/material";
import style from "./style";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import {ReactComponent as Edit}from "../../assets/images/edit.svg";
import dayjs from "dayjs";
import { formatDate } from "../../utils/DateFormat";
// import { useLocation } from "react-router-dom";
const SDLPage = ({ sdl, deleteSdl, createSdl ,handleEditSdl, sdlCountry }) => {
  // const options = countryList().getData();
  const [open, setOpen] = useState(false);
  const [min, setMin] = useState();
  const [datefrom, setDateFrom] = useState();
  const [dateTo, setDateTo] = useState()
  // const [Maxnwe, setMaxnwe] = useState();
  const [country, setCountry] = useState();
  const [opens, setOpens] = useState(false);
  const [value, setValue] = useState();
  // const [editOpen, setEditOpen] = useState(false);
  const [selectedSDL, setSelectedSDL] = useState(null);


  useEffect(() => {
    if (!open) {
      setOpen(false);
      setMin("")
      setSelectedSDL(null);
      setDateFrom("");
      setDateFrom(null);
      setDateTo(null);
    }
  }, [open]);

 
  const handleDeleteItem = () => {
    deleteSdl(value)
    setOpens(false);
  };

  const deleteData = (item) => {
    setValue(item);
  };

  const handleEdit = (item) => {
    setSelectedSDL(item);
    setMin(item?.employerSDL || "");
    setDateFrom(item.startYear ? dayjs(item.startYear) : null);
    setDateTo(item.endYear ? dayjs(item.endYear) : null);
    setCountry(country)
    setOpen(true);
  };


  const handleSubmit = () => {
    if (selectedSDL) {
      handleEditSdl(selectedSDL?._id, min, sdlCountry, datefrom, dateTo);
    } else {
      createSdl(min, country, datefrom, dateTo);
    }
    setOpen(false);
  };

  const isDisabled = !min || !datefrom || !dateTo;

  return (

    <>

      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 2 ,mt:3,ml:3,mr:2}}>
        <Typography sx={style.gridText}>SDL Tables</Typography>
        <Button
          variant="contained"
          type="submit"
          color="success"
          sx={style.jobButtons}
          onClick={() => {
            setOpen(true)
            setCountry(sdlCountry)         
          }}
        >+ Add
        </Button>
      </Box>
      <Grid container sx={style.mainContainer}>
        <Grid item xs={12} lg={12} sx={style.gridbox}>
          <Typography sx={style.gridTexttable}>{sdlCountry}</Typography>
          <Box sx={style.modalGrid}>
          </Box>
          <TableContainer sx={style.noShadow}>
            <Table>
              <TableHead>
                <TableRow>
                  {/* <TableCell sx={style.tableHead}>Country</TableCell> */}
                  <TableCell sx={style.tableHead}>SDL</TableCell>
                  <TableCell sx={style.tableHead}>Start Year</TableCell>
                  <TableCell sx={style.tableHead}>End Year</TableCell>
                  <TableCell sx={style.tableHead}>Update Date</TableCell>
                  <TableCell sx={style.TableHead}>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sdl?.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      <Typography variant="h6">No Data</Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  sdl?.map((item, index) => (
                    <TableRow key={index}>
                      {/* <TableCell sx={style.tableData}>
                        {item?.country}
                      </TableCell> */}
                      <TableCell sx={style.tableData}>
                        {item?.employerSDL}
                      </TableCell>
                      <TableCell sx={style.tableData}>
                        {formatDate(item?.startYear)}
                      </TableCell>
                      <TableCell sx={style.tableData}>
                        {formatDate(item?.endYear)}
                      </TableCell>
                      <TableCell sx={style.tableData}>
                        {formatDate(item?.updatedAt)}
                      </TableCell>
                      <TableCell sx={style.tabledata}>
                        <Box sx={style.tableActiondata}>
                          <Edit style={{ cursor: "pointer", margin:3 }} onClick={() => handleEdit(item)} />
                          <DeleteOutlineIcon
                            sx={{ color: "#ff0000" }}
                            onClick={() => {
                              deleteData(item?._id), setOpens(true);
                            }}
                          />
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
      <Modal
        open={open}
        setOpen={setOpen}
        disabled={isDisabled}
        btnText={selectedSDL ? "Update SDL" : "Create SDL"}
        title={selectedSDL ? "Edit SDL" : "Create SDL"}
        handleCheck={handleSubmit}
      >
        <Box sx={style.modalGrid}>
          <Box style={style.boxs2}>
            <InputLabel sx={style.label}>Employer</InputLabel>
            <TextField
              name="desc"
              value={min}
              onChange={(e) => {
                setMin(e.target.value);
              }}
              style={style.boxs2}
            />
          </Box>
        </Box>

        <Box sx={style.modalGrid}>
          <Box sx={style.inputBoxs}>
            <Typography sx={style.inputTexts}>Start Year</Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Box>
                <DatePicker
                  value={datefrom}
                  slotProps={{
                    field: {
                      readOnly: true
                    }
                  }}
                  sx={style.calenderInput}
                  onChange={(newValue) => { setDateFrom(newValue); }}
                />
              </Box>
            </LocalizationProvider>
          </Box>
          <Box sx={style.inputBoxs}>
            <Typography sx={style.inputTexts}>End Year</Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={dateTo}
                slotProps={{
                  field: {
                    readOnly: true
                  }
                }}
                sx={style.calenderInput}
                onChange={(newValue) => { setDateTo(newValue); }}
              />
            </LocalizationProvider>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={opens}
        setOpen={setOpens}
        deletetText={"Delete"}
        cancelText={"Cancel"}
        title={"Delete SDL"}
        handleDelete={handleDeleteItem}
      >
        <Box>
          <Typography>Are you sure you want to Delete?</Typography>
        </Box>
      </Modal>
    </>
  );
};

export default SDLPage;
